module.exports = __webpack_public_path__ + "img/showMore.de0d03db.png";